import { forEach } from 'lodash';
import React, { useContext } from 'react'
import { FormContext } from '../../FormContext';
import './RadioBtn.css';
import { isFieldSigned, determineIsDisabled } from './utils.js';
import useIsMobile from '../../hooks/useIsMobile'; // Adjust the import path as needed

const RadioBtn = ({ field_column, field_align, field_id, field_disabled, field_label, field_mandatory, field_options, field_value, field_multiple_type, field_multiple_id, field_disabled_approver }) => {
    const { handleChangeInput, formStatus, formPageType, formApprovalIndex, formUserLock, formMultipleType, formChatPerson, formOfficers } = useContext(FormContext);
    const isMobile = useIsMobile();

    let isSigned = isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type);
    const isDisabled = determineIsDisabled(
        formUserLock,
        formPageType,
        field_multiple_id,
        isSigned,
        field_id,
        formApprovalIndex,
        field_disabled_approver,
        field_disabled,
        formStatus
    );

    // Force vertical alignment on mobile
    const effectiveAlignment = isMobile ? "vertical" : field_align;

    return (
        <div className={`form-group ${field_column ? field_column : 'col-lg-6'}`} onChange={event => handleChangeInput(field_id, event)}>
            <label>{field_label} <font color="red">{field_mandatory === 'yes' ? ' *' : ''}</font></label>
            <br />

            {field_options?.length > 0 && field_options.map((option, i) =>
                <React.Fragment key={i}>
                    <input
                        type="radio"
                        checked={field_value === option.option_label.trim()}
                        value={JSON.stringify(option)}
                        name={field_id}
                        disabled={isDisabled}
                        className="form-check-input"
                    />
                    <label className="form-check-label">{option.option_label} </label>
                    {effectiveAlignment === "vertical" && <br />}
                </React.Fragment>
            )}
        </div>
    )
}

export default RadioBtn